import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-left',
  templateUrl: './icon-arrow-left.component.html',
  styleUrls: ['./icon-arrow-left.component.scss']
})
export class IconArrowLeftComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;
  
  constructor() { }

  ngOnInit() {
  }

}
